import { render, staticRenderFns } from "./HeaderSelector.vue?vue&type=template&id=ce47573e&scoped=true"
import script from "./HeaderSelector.vue?vue&type=script&lang=js"
export * from "./HeaderSelector.vue?vue&type=script&lang=js"
import style0 from "./HeaderSelector.vue?vue&type=style&index=0&id=ce47573e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce47573e",
  null
  
)

export default component.exports